(function () {
  var DEFAULT_AUTOPLAY_MS = 7000;

  function isMobileCarousel() {
    return typeof window !== 'undefined' && window.matchMedia && window.matchMedia('(max-width: 767.98px)').matches;
  }

  function perView(carousel) {
    if (isMobileCarousel()) return 1;
    var xl = parseInt(carousel.getAttribute('data-iia-per-xl') || '5', 10);
    var lg = parseInt(carousel.getAttribute('data-iia-per-lg') || '3', 10);
    var md = parseInt(carousel.getAttribute('data-iia-per-md') || '2', 10);
    var sm = parseInt(carousel.getAttribute('data-iia-per-sm') || '1', 10);
    if (typeof window === 'undefined' || !window.matchMedia) return Math.max(1, xl);
    if (window.matchMedia('(min-width: 1200px)').matches) return Math.max(1, xl);
    if (window.matchMedia('(min-width: 1024px)').matches) return Math.max(1, lg);
    if (window.matchMedia('(min-width: 768px)').matches) return Math.max(1, md);
    return Math.max(1, sm);
  }

  function activeSlideIndex(track, slides) {
    var scroll = track.scrollLeft;
    var index = 0;
    var best = Infinity;
    for (var i = 0; i < slides.length; i++) {
      var dist = Math.abs(slides[i].offsetLeft - scroll);
      if (dist < best) {
        best = dist;
        index = i;
      }
    }
    return index;
  }

  function ensureVideoSrc(video) {
    if (!video) return;
    var sources = video.querySelectorAll('source[data-src]');
    var changed = false;
    if (sources.length) {
      for (var i = 0; i < sources.length; i++) {
        var source = sources[i];
        if (source.dataset.src && !source.getAttribute('src')) {
          source.setAttribute('src', source.dataset.src);
          source.removeAttribute('data-src');
          changed = true;
        }
      }
    }
    if (video.dataset.src && !video.getAttribute('src')) {
      video.setAttribute('src', video.dataset.src);
      video.removeAttribute('data-src');
      changed = true;
    }
    if (changed && video.readyState < 1) {
      try {
        video.load();
      } catch (e) {}
    }
  }

  function setPlayUi(wrap, playing) {
    wrap.classList.toggle('is-playing', playing);
  }

  function pauseWrap(wrap) {
    var video = wrap.querySelector('video.iia-video');
    if (video) {
      video.pause();
      video.muted = true;
    }
    setPlayUi(wrap, false);
  }

  function pauseAllVideos(exceptWrap) {
    document.querySelectorAll('[data-iia-video-wrap]').forEach(function (wrap) {
      if (wrap === exceptWrap) return;
      pauseWrap(wrap);
    });
  }

  function playWrap(wrap, restart, options) {
    options = options || {};
    var video = wrap.querySelector('video.iia-video');
    if (!video) return Promise.resolve();

    ensureVideoSrc(video);
    pauseAllVideos(wrap);
    video.muted = options.unmuted !== true;

    if (restart) {
      try {
        video.currentTime = 0;
      } catch (e) {}
    }

    return video
      .play()
      .then(function () {
        setPlayUi(wrap, true);
      })
      .catch(function () {
        setPlayUi(wrap, false);
      });
  }

  function slideWrap(slide) {
    return slide ? slide.querySelector('[data-iia-video-wrap]') : null;
  }

  function preloadSlideVideo(slide) {
    var wrap = slideWrap(slide);
    if (!wrap) return;
    var video = wrap.querySelector('video.iia-video');
    if (!video) return;
    ensureVideoSrc(video);
    if (video.readyState < 1) {
      try {
        video.load();
      } catch (e) {}
    }
  }

  function mobileStarted(carousel) {
    return !!(carousel && carousel.dataset.iiaMobileStarted === '1');
  }

  function markMobileStarted(carousel) {
    if (carousel) carousel.dataset.iiaMobileStarted = '1';
  }

  function initVideoWrap(wrap) {
    if (!wrap || wrap.dataset.iiaVideoInit === '1') return;
    var btn = wrap.querySelector('[data-iia-play]');
    var video = wrap.querySelector('video.iia-video');
    if (!video) return;

    wrap.dataset.iiaVideoInit = '1';
    var carousel = wrap.closest('[data-iia-carousel]');

    video.addEventListener('play', function () {
      pauseAllVideos(wrap);
      setPlayUi(wrap, true);
    });

    video.addEventListener('pause', function () {
      if (!video.ended) setPlayUi(wrap, false);
    });

    video.addEventListener('ended', function () {
      setPlayUi(wrap, false);
      video.muted = true;
    });

    function userPlay() {
      if (isMobileCarousel()) markMobileStarted(carousel);
      playWrap(wrap, false, { unmuted: true });
    }

    if (btn) {
      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        e.preventDefault();
        if (!video.paused) return;
        userPlay();
      });
    }

    wrap.addEventListener('click', function (e) {
      if (e.target.closest('[data-iia-play]')) return;

      if (isMobileCarousel()) {
        if (!wrap.classList.contains('is-playing')) return;
        e.preventDefault();
        video.pause();
        video.muted = true;
        return;
      }

      if (!wrap.classList.contains('is-playing')) {
        e.preventDefault();
        if (video.paused) userPlay();
      } else {
        e.preventDefault();
        video.pause();
        video.muted = true;
      }
    });
  }

  function initCarousel(carousel) {
    if (!carousel || carousel.dataset.iiaInit === '1') return;
    var track = carousel.querySelector('[data-iia-track]');
    var slides = track ? carousel.querySelectorAll('[data-iia-slide]') : [];
    var dotsWrap = carousel.querySelector('[data-iia-dots]');
    var prevBtn = carousel.querySelector('[data-iia-prev]');
    var nextBtn = carousel.querySelector('[data-iia-next]');
    if (!track || !slides.length) return;

    carousel.dataset.iiaInit = '1';
    carousel.querySelectorAll('[data-iia-video-wrap]').forEach(initVideoWrap);

    var index = 0;
    var maxIndex = Math.max(0, slides.length - perView(carousel));
    var mobileAutoFromNav = false;
    var autoplayMs = parseInt(carousel.getAttribute('data-iia-autoplay-ms') || String(DEFAULT_AUTOPLAY_MS), 10);
    if (!Number.isFinite(autoplayMs) || autoplayMs < 1000) autoplayMs = DEFAULT_AUTOPLAY_MS;
    var autoplayEnabled = carousel.getAttribute('data-iia-autoplay') !== 'false';
    var autoplayTimer = null;
    var userPausedAutoplay = false;

    function updateDots() {
      if (!dotsWrap) return;
      dotsWrap.querySelectorAll('[data-iia-dot]').forEach(function (dot, i) {
        var on = i === index;
        dot.classList.toggle('is-active', on);
        dot.setAttribute('aria-current', on ? 'true' : 'false');
      });
    }

    function updateNav() {
      if (prevBtn) prevBtn.disabled = index <= 0;
      if (nextBtn) nextBtn.disabled = index >= maxIndex;
    }

    function stopAutoplay() {
      if (autoplayTimer) {
        window.clearInterval(autoplayTimer);
        autoplayTimer = null;
      }
    }

    function startAutoplay() {
      stopAutoplay();
      if (!autoplayEnabled || userPausedAutoplay || maxIndex < 1) return;
      autoplayTimer = window.setInterval(function () {
        var next = index >= maxIndex ? 0 : index + 1;
        scrollToIndex(next, 'smooth', { fromAutoplay: true });
      }, autoplayMs);
    }

    function resetAutoplay() {
      userPausedAutoplay = false;
      startAutoplay();
    }

    function syncMobileActiveSlide(restart, options) {
      options = options || {};
      if (!isMobileCarousel() || !mobileStarted(carousel)) return;

      slides.forEach(function (slide, i) {
        if (i === index) return;
        var wrap = slideWrap(slide);
        if (wrap) pauseWrap(wrap);
      });

      var activeWrap = slideWrap(slides[index]);
      if (activeWrap) playWrap(activeWrap, restart !== false, { unmuted: options.unmuted === true });
    }

    function scrollToIndex(i, behavior, options) {
      options = options || {};
      index = Math.max(0, Math.min(i, maxIndex));
      var slide = slides[index];
      if (!slide) return;

      preloadSlideVideo(slide);
      if (slides[index - 1]) preloadSlideVideo(slides[index - 1]);
      if (slides[index + 1]) preloadSlideVideo(slides[index + 1]);

      pauseAllVideos(null);

      track.scrollTo({ left: slide.offsetLeft, behavior: behavior || 'smooth' });
      updateDots();
      updateNav();

      if (isMobileCarousel() && options.mobileAuto && mobileStarted(carousel)) {
        var delay = behavior === 'smooth' ? 320 : 0;
        window.setTimeout(function () {
          syncMobileActiveSlide(true, { unmuted: false });
        }, delay);
      } else if (isMobileCarousel()) {
        pauseAllVideos(null);
      }

      if (!options.fromAutoplay) resetAutoplay();
    }

    function onScrollEnd() {
      var prev = index;
      index = Math.max(0, Math.min(activeSlideIndex(track, slides), maxIndex));
      updateDots();
      updateNav();

      if (!isMobileCarousel() || !mobileStarted(carousel)) return;

      if (mobileAutoFromNav) {
        mobileAutoFromNav = false;
        return;
      }

      if (index !== prev) {
        syncMobileActiveSlide(true, { unmuted: false });
      }
    }

    var scrollTimer;
    track.addEventListener('scroll', function () {
      window.clearTimeout(scrollTimer);
      scrollTimer = window.setTimeout(onScrollEnd, 80);
    });

    if (dotsWrap) {
      dotsWrap.addEventListener('click', function (e) {
        var dot = e.target.closest('[data-iia-dot]');
        if (!dot) return;
        var i = parseInt(dot.getAttribute('data-iia-dot'), 10);
        if (isNaN(i)) return;
        scrollToIndex(i);
      });
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        mobileAutoFromNav = isMobileCarousel();
        scrollToIndex(index - 1, 'smooth', { mobileAuto: true });
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        mobileAutoFromNav = isMobileCarousel();
        scrollToIndex(index + 1, 'smooth', { mobileAuto: true });
      });
    }

    carousel.addEventListener('pointerdown', function () {
      userPausedAutoplay = true;
      stopAutoplay();
    });

    carousel.addEventListener('pointerup', function () {
      window.setTimeout(function () {
        if (!userPausedAutoplay) return;
        resetAutoplay();
      }, autoplayMs);
    });

    function onResize() {
      var wasMobile = carousel.dataset.iiaWasMobile === '1';
      var nowMobile = isMobileCarousel();

      maxIndex = Math.max(0, slides.length - perView(carousel));
      if (nowMobile) {
        index = Math.max(0, Math.min(index, slides.length - 1));
      } else if (index > maxIndex) {
        scrollToIndex(maxIndex, 'auto');
        return;
      }

      if (wasMobile && !nowMobile) {
        carousel.dataset.iiaMobileStarted = '';
        pauseAllVideos(null);
      }

      carousel.dataset.iiaWasMobile = nowMobile ? '1' : '0';
      scrollToIndex(index, 'auto');
    }

    carousel.dataset.iiaWasMobile = isMobileCarousel() ? '1' : '0';
    window.addEventListener('resize', onResize);
    updateDots();
    updateNav();

    if (isMobileCarousel()) {
      pauseAllVideos(null);
    } else {
      preloadSlideVideo(slides[0]);
    }

    startAutoplay();
  }

  function boot(scope) {
    var root = scope || document;
    var carousels = root.querySelectorAll('[data-iia-carousel]');
    if (!carousels.length) {
      root.querySelectorAll('[data-iia-video-wrap]').forEach(initVideoWrap);
      return;
    }

    function hydrateCarousel(carousel) {
      initCarousel(carousel);
      if (!isMobileCarousel()) {
        var track = carousel.querySelector('[data-iia-track]');
        var slides = track ? track.querySelectorAll('[data-iia-slide]') : [];
        if (slides[0]) preloadSlideVideo(slides[0]);
        if (slides[1]) preloadSlideVideo(slides[1]);
      }
    }

    carousels.forEach(function (carousel) {
      if (carousel.dataset.iiaInit === '1') return;
      if (typeof IntersectionObserver === 'undefined') {
        hydrateCarousel(carousel);
        return;
      }
      var once = false;
      var io = new IntersectionObserver(
        function (entries) {
          if (once) return;
          if (!entries[0] || !entries[0].isIntersecting) return;
          once = true;
          io.disconnect();
          hydrateCarousel(carousel);
        },
        { root: null, rootMargin: '200px 0px', threshold: 0.01 }
      );
      io.observe(carousel);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) {
    if (!e.target) return;
    e.target.querySelectorAll('[data-iia-carousel]').forEach(function (el) {
      delete el.dataset.iiaInit;
      delete el.dataset.iiaMobileStarted;
      delete el.dataset.iiaWasMobile;
    });
    e.target.querySelectorAll('[data-iia-video-wrap]').forEach(function (el) {
      delete el.dataset.iiaVideoInit;
    });
    boot(e.target);
  });
})();
